import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckCircle2Icon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="bg-[#0a0a0a] py-24 px-4 relative" data-id="element-76">
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-900/10 to-transparent pointer-events-none" data-id="element-77" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-80">
            Hoy no solo compras un ebook. Compras el{' '}
            <span className="text-indigo-400" data-id="element-81">
              Creator Monetization OS v2026
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-[#111111] rounded-3xl border border-indigo-500/30 p-8 md:p-12 shadow-[0_0_50px_rgba(99,102,241,0.15)] relative overflow-hidden" data-id="element-82">
          {/* Badge */}
          <div className="absolute top-6 right-6 bg-red-500 text-white text-sm font-bold px-4 py-1.5 rounded-full shadow-lg transform rotate-3" data-id="element-83">
            85% OFF
          </div>

          <div className="flex flex-col items-center mb-10" data-id="element-84">
            <div className="flex items-start gap-3 mb-8 w-full max-w-md bg-[#0a0a0a] p-4 rounded-xl border border-white/5" data-id="element-85">
              <CheckCircle2Icon className="w-6 h-6 text-indigo-400 flex-shrink-0 mt-0.5" data-id="element-86" />
              <div data-id="element-87">
                <h3 className="text-white font-bold text-lg" data-id="element-88">
                  Ebook Principal: Creator OS
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-89">
                  Tu hoja de ruta de 0 a $2k/mes.
                </p>
                <p className="text-gray-500 text-sm line-through mt-1" data-id="element-90">
                  Valor $97
                </p>
              </div>
            </div>

            <div className="text-center mb-8" data-id="element-91">
              <p className="text-gray-400 text-lg mb-2" data-id="element-92">PRECIO HOY:</p>
              <div className="flex items-center justify-center gap-4" data-id="element-93">
                <span className="text-3xl text-gray-500 line-through decoration-red-500/70 decoration-2" data-id="element-94">
                  $97
                </span>
                <span className="text-6xl md:text-7xl font-extrabold text-green-400 tracking-tight" data-id="element-95">
                  $6.36
                </span>
              </div>
            </div>

            <CTAButton className="w-full md:w-auto md:px-12 py-5 text-xl" data-id="element-96">
              SÍ, QUIERO ACCESO INMEDIATO
            </CTAButton>
          </div>

          <div className="border-t border-white/10 pt-8 mt-4" data-id="element-97">
            <h4 className="text-white font-bold text-xl mb-4 text-center" data-id="element-98">
              ¿Por qué solo $6.36?
            </h4>
            <p className="text-gray-300 leading-relaxed mb-4 text-center max-w-2xl mx-auto" data-id="element-99">
              Porque sé que en Latinoamérica el primer paso es el más difícil.
              Quiero que el precio sea la menor de tus preocupaciones para que
              empieces a construir tu libertad hoy mismo. Pero ojo: este precio
              es una oferta de validación de mercado.
            </p>
            <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-4 text-center max-w-xl mx-auto" data-id="element-100">
              <p className="text-red-400 font-medium" data-id="element-101">
                Una vez que alcancemos los 100 alumnos, el precio subirá a su
                valor real de $97.{' '}
                <strong className="text-white" data-id="element-102">
                  Ahorra si tomas acción ahora.
                </strong>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}